export enum ApplicationConnectType {
    Bebop = 1
}